import { Injectable, ErrorHandler } from '@angular/core';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { errorMessages } from '../constants/error-message.constants';
import { LoggingService } from './logging.service';
import { CustomException } from '../models/i-custom-exception.modal';
import { IMessage } from '../models/message.modal';

// MSAL error codes for a login that has expired and needs renewing
const LOGIN_RENEWAL_ERROR_CODES = ['interaction_required', 'login_required', 'no_tokens_found', 'refresh_token_expired', 'bad_token'];

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private loggingService: LoggingService, private dialogService: DialogService) {}
  handleError(error: any): void {
    // Errors from rejected promises can arrive wrapped
    error = error?.rejection ?? error;
    if (error instanceof Error) {
      console.log(error);
      const newGuid: string = this.loggingService.generateGuid();
      const logError: CustomException = {
        frondendID: newGuid,
        message: '',
        backendID: '',
        stack: error.stack,
      };
      // These sign-in errors only mean the login expired (e.g. after the user is idle) and MSAL
      // is signing the user back in, so they are logged without showing the error dialog.
      // Any other sign-in error still shows the dialog.
      if (error instanceof InteractionRequiredAuthError && LOGIN_RENEWAL_ERROR_CODES.includes(error.errorCode)) {
        console.warn('Login expired, signing back in:', error.errorCode);
        this.loggingService.logEvent('Auth Error', { ...logError, message: error.errorCode });
        return;
      }
      this.loggingService.logEvent('UI Error', logError);
      const errorMessage: IMessage = errorMessages.uiError;
      errorMessage.errorID = newGuid;
      this.dialogService.uiErrorOpen(errorMessage);
    }
  }
}
